const SOLIDSPORT_BASE_URL = 'https://www.solidsport.com'
const LOCALE_PREFIXED_TERMS = new Set(['sv', 'de'])

export const getTermsLink = (language?: string): string =>
  language && LOCALE_PREFIXED_TERMS.has(language)
    ? `${SOLIDSPORT_BASE_URL}/${language}/our-terms`
    : `${SOLIDSPORT_BASE_URL}/our-terms`
